"use client";

import { useCallback, useEffect } from "react";
import { flushSync } from "react-dom";
import { useLoading } from "../contexts/LoadingContext";
import { isResearchDeskPath } from "@/lib/research-desk/paths";
import { isModifiedMouseEvent } from "@/lib/stockNavigationFeedback";

function deskHrefFromEvent(target: EventTarget | null): string | null {
  if (!(target instanceof Element)) return null;
  const anchor = target.closest("a[href^='/pulse']");
  if (!anchor || anchor.getAttribute("target") === "_blank") return null;
  return anchor.getAttribute("href");
}

export default function DeskNavigationHandler() {
  const { setLoading, setLoadingMessage } = useLoading();

  const showLoading = useCallback(() => {
    flushSync(() => {
      setLoadingMessage("Loading…");
      setLoading(true);
    });
  }, [setLoading, setLoadingMessage]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (isModifiedMouseEvent(e)) return;

      const href = deskHrefFromEvent(e.target);
      if (!href) return;
      if (href === window.location.pathname) return;
      // Layout stays mounted inside Desk, so a full-screen overlay would
      // never get a remount-clear. The in-page loading slot is enough.
      if (isResearchDeskPath(window.location.pathname)) return;

      showLoading();
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [showLoading]);

  return null;
}
